import {GET_CASES_REQUEST,
    GET_CASES_SUCCESS,
    GET_CASES_FAILURE,
    CHANGE_CASE_STATUS_REQUEST,
    CHANGE_CASE_STATUS_SUCCESS,
    CHANGE_CASE_STATUS_FAILURE,
    GET_CASE_DETAILS_FAILURE,
    GET_CASE_DETAILS_REQUEST,
    GET_CASE_DETAILS_SUCCESS
} from './constants';

export function getCases(page, filterOptions, sortingOptions) {
    return {
        type: GET_CASES_REQUEST,
        data: {page, filterOptions, sortingOptions}
    }
}

export function getCasesSuccess(response) {
    return {
        type: GET_CASES_SUCCESS,
        data: response
    }
}

export function getCasesFailure() {
    return {
        type: GET_CASES_FAILURE,
        data: {}
    }
}

export function changeCaseStatus(data, page, filterOptions, sortingOptions) {
    return {
        type: CHANGE_CASE_STATUS_REQUEST,
        data: {data, page, filterOptions, sortingOptions}
    }
}

export function changeCaseStatusSuccess(response) {
    return {
        type: CHANGE_CASE_STATUS_SUCCESS,
        data: response
    }
}

export function changeCaseStatusFailure() {
    return {
        type: CHANGE_CASE_STATUS_FAILURE,
        data: {}
    }
}

export function getCase(caseId) {
    return {
        type: GET_CASE_DETAILS_REQUEST,
        caseId: caseId
    }
}

export function getCaseSuccess(response) {
    return {
        type: GET_CASE_DETAILS_SUCCESS,
        data: response
    }
}

export function getCaseFailure() {
    return {
        type: GET_CASE_DETAILS_FAILURE,
        data: {}
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AllCases/actions.js